module.exports = __webpack_public_path__ + "static/media/edit-icon.1990e390.svg";